import React from "react";
import { AiOutlineEye } from "react-icons/ai";
import { BiCaretLeft, BiEdit } from "react-icons/bi";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import Loading from "../../Components/Loading";
import { useSingle } from "./Hooks";
import "./index.scss";
const SingleMyAds = () => {
  console.log("kos nane b");
  const { navigate, form, loading, renderStatus } = useSingle();
  return (
    <div className="single-ads-">
      <header className="d-flex justify-content-between">
        <div className="d-flex  align-items-center">
          <button
            className="btn"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowRight />
          </button>
          <p className="fs-12 m-0">مدیریت آگهی</p>
        </div>
      </header>
      {loading.show ? (
        <Loading />
      ) : (
        <>
          <div className="container">
            <div className="row mt-3">
              <div className="col-12">
                <div className="border rounded d-flex align-items-center">
                  <div style={{ flex: 1 }}>
                    <img
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "contain",
                      }}
                      src={form.main_image.url}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ textAlign: "center" }}>{form.title}</p>
                    <p style={{ textAlign: "center", fontSize: "12px" }}>
                      {renderStatus(form.status)["title"]}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row menu-bar">
              <div className="col-12">
                {[
                  {
                    title: "پیش نمایش",
                    icon: AiOutlineEye,
                    route: "/my-ads-preview",
                  },
                  {
                    title: "ویرایش",
                    icon: BiEdit,
                    route: "/my-ads-edit",
                  },
                ].map((item, key) => {
                  if (item.route == "/my-ads-edit") {
                    if (renderStatus(form.status)["edit"]) {
                      return (
                        <div
                          key={key}
                          onClick={() => {
                            navigate(item.route + `/${form.id}`);
                          }}
                          className="menu-bar-item d-flex align-items-center justify-content-between "
                        >
                          <div className="d-flex align-items-center">
                            {<item.icon />}
                            <h3>{item.title}</h3>
                          </div>
                          <div>
                            <BiCaretLeft />
                          </div>
                        </div>
                      );
                    }
                  } else {
                    return (
                      <div
                        key={key}
                        onClick={() => {
                          navigate(item.route + `/${form.id}`);
                        }}
                        className="menu-bar-item d-flex align-items-center justify-content-between "
                      >
                        <div className="d-flex align-items-center">
                          {<item.icon />}
                          <h3>{item.title}</h3>
                        </div>
                        <div>
                          <BiCaretLeft />
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SingleMyAds;
